/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Members_Add_Free_Seats_ManyInputs */



/**
* | output |
* | --- |
* | "{count} free seats – no extra cost" |
*
* @param {Members_Add_Free_Seats_ManyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_free_seats_many = /** @type {((inputs: Members_Add_Free_Seats_ManyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Free_Seats_ManyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} freie Plätze – keine Zusatzkosten`)
	return /** @type {LocalizedString} */ (`${i?.count} free seats – no extra cost`)
});